import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { SelectOption } from '@vpfa/ui-kit';

/**
 * Validates if option is selected
 */
export function nonEmptySelectionValidator(control: AbstractControl): ValidationErrors | null {
  const error = { nonEmptySelection: true };

  if (control.value === null || control.value === undefined || control.value === '') {
    return error;
  }

  const optionControl = control.value as SelectOption;
  const optionValue = optionControl.value;

  if (!!optionControl.name && (optionValue === null || optionValue === undefined || optionValue === '')) {
    return error;
  }

  return null;
}
